module.exports = "/images/vendor/flag-icon-css/flags/4x3/ec.svg?5d6fdbf808b19221f220ae2e0e991017";